//import { actionTypes } from "react-redux-firebase";

const initialState = {
    highlightedCourse: 'none',
    NumberOfLectures: 0,
    highlightedLecture: 'none',
    CourseNumberOfQuestions: 0,
    LectureNumberOfQuestions: 0,
    AccountNumberOfQuestions: 0,
    AccountNumberOfQListDocuments: 1,
    NumberOfQuestionsInList: 0,
    QuestionList: 'empty',
    FullQuestionList: [],
}

const highlightedContentReducer = (state = initialState, action) => {
    //detect the createLecture through the switch statements.

    switch (action.type) {

        case 'HIGHLIGHT_CONTENT_DURING_CREATION_DISPATCH':

            return {
                highlightedCourse: action.highlightedCourse,
                NumberOfLectures: action.NumberOfLectures,
                highlightedLecture: action.highlightedLecture,
                CourseNumberOfQuestions: action.CourseNumberOfQuestions,
                LectureNumberOfQuestions: action.LectureNumberOfQuestions,
                AccountNumberOfQuestions: action.AccountNumberOfQuestions,
                AccountNumberOfQListDocuments: action.AccountNumberOfQListDocuments,
                NumberOfQuestionsInList: action.NumberOfQuestionsInList,
                QuestionList: action.QuestionList,
                FullQuestionList: action.FullQuestionList,

            }

        case 'RESET_HIGHLIGHT_CONTENT_DURING_LOGOUT':

        return{
            highlightedCourse: action.highlightedCourse,
            NumberOfLectures: action.NumberOfLectures,
            highlightedLecture: action.highlightedLecture,
            CourseNumberOfQuestions: action.CourseNumberOfQuestions,
            LectureNumberOfQuestions: action.LectureNumberOfQuestions,
            AccountNumberOfQuestions: action.AccountNumberOfQuestions,
            AccountNumberOfQListDocuments: action.AccountNumberOfQListDocuments,
            NumberOfQuestionsInList: action.NumberOfQuestionsInList,
            QuestionList: action.QuestionList,
            FullQuestionList: action.FullQuestionList,
        }

        case 'REMOVE_QUESTION_FROM_FULLQUESTIONLIST':

            
            return {
                highlightedCourse: action.highlightedCourse,
                NumberOfLectures: action.NumberOfLectures,
                highlightedLecture: action.highlightedLecture,
                CourseNumberOfQuestions: action.CourseNumberOfQuestions,
                LectureNumberOfQuestions: action.LectureNumberOfQuestions,
                AccountNumberOfQuestions: action.AccountNumberOfQuestions,
                AccountNumberOfQListDocuments: action.AccountNumberOfQListDocuments,
                NumberOfQuestionsInList: action.NumberOfQuestionsInList,
                QuestionList: action.QuestionList,
                FullQuestionList: action.FullQuestionList,



            }


        case 'CREATE_NEW_QLIST':
            return{
                highlightedCourse: action.highlightedCourse,
                NumberOfLectures: action.NumberOfLectures,
                highlightedLecture: action.highlightedLecture,
                CourseNumberOfQuestions: action.CourseNumberOfQuestions,
                LectureNumberOfQuestions: action.LectureNumberOfQuestions,
                AccountNumberOfQuestions: action.AccountNumberOfQuestions,
                AccountNumberOfQListDocuments: action.AccountNumberOfQListDocuments,
                NumberOfQuestionsInList: action.NumberOfQuestionsInList,
                QuestionList: action.QuestionList,
                FullQuestionList: action.FullQuestionList,
            }

        case 'HIGHLIGHT_READ_QUESTION_LIST':
            return{
                highlightedCourse: action.highlightedCourse,
                NumberOfLectures: action.NumberOfLectures,
                highlightedLecture: action.highlightedLecture,
                CourseNumberOfQuestions: action.CourseNumberOfQuestions,
                LectureNumberOfQuestions: action.LectureNumberOfQuestions,
                AccountNumberOfQuestions: action.AccountNumberOfQuestions,
                AccountNumberOfQListDocuments: action.AccountNumberOfQListDocuments,
                NumberOfQuestionsInList: action.NumberOfQuestionsInList,
                QuestionList: action.QuestionList,
                FullQuestionList: action.FullQuestionList,

            }

        

        


        default:
            return state;
    }

}

export default highlightedContentReducer